module.exports = __webpack_public_path__ + "public/img/situationC.6d1fc012.png";